import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.filter";
import _isEmpty from "lodash/isEmpty";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import classes from '@nerdwallet/base-styles/classes';
import { Type } from '@nerdwallet/currency';
import { ControlledAccordion } from '@nerdwallet/react-accordion';
import OptionalListContent from '../optional-list-content';
import styles from './keto-product-card.module.less';
import { buildAnalyticsEntityName } from '../lib/utils';

var ItemImpression = function ItemImpression(_ref) {
  var children = _ref.children,
      entityName = _ref.entityName,
      payload = _ref.payload;
  var impressionContext = useContext(ImpressionContext);

  var newPayload = _cloneDeep(payload);

  if (impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId) {
    _set(newPayload, 'parent_impression_id', impressionContext.impressionId);
  }

  return /*#__PURE__*/React.createElement(Impression, {
    entityName: entityName,
    payload: newPayload
  }, children);
};

ItemImpression.propTypes = {
  children: PropTypes.node,
  entityName: PropTypes.string,
  payload: PropTypes.object // eslint-disable-line react/forbid-prop-types

};

var KetoAccordionItemWrapper = function KetoAccordionItemWrapper(_ref2) {
  var analyticsEnabled = _ref2.analyticsEnabled,
      children = _ref2.children,
      entityName = _ref2.entityName,
      payload = _ref2.payload;

  if (analyticsEnabled) {
    return /*#__PURE__*/React.createElement(ItemImpression, {
      entityName: entityName,
      payload: payload
    }, children);
  }

  return /*#__PURE__*/React.createElement(Fragment, null, children);
};

KetoAccordionItemWrapper.propTypes = {
  analyticsEnabled: PropTypes.bool,
  children: PropTypes.node,
  entityName: PropTypes.string,
  payload: PropTypes.object // eslint-disable-line react/forbid-prop-types

};
var entityName = 'keto_card_accordion';
var sectionName = 'keto_product_card_more_details';
var entityNamePrefix = "".concat(sectionName, "_");

var KetoAccordion = function KetoAccordion(_ref3) {
  var _analytics$ourTakePro, _analytics$ourTakePro2, _analytics$ourTakePro3, _analytics$productDet, _analytics$productDet2, _analytics$productDet3, _analytics$payload;

  var analytics = _ref3.analytics,
      bottomLine = _ref3.bottomLine,
      cons = _ref3.cons,
      enableAnalytics = _ref3.enableAnalytics,
      initAccordionItemExpanded = _ref3.initAccordionItemExpanded,
      productDetails = _ref3.productDetails,
      pros = _ref3.pros;
  useDeprecatedPropsWarning({
    component: 'KetoAccordion',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var hasPros = !_isEmpty(pros);
  var hasCons = !_isEmpty(cons);
  var prosContent = /*#__PURE__*/React.createElement(OptionalListContent, {
    content: pros,
    contentLabel: "Pros",
    className: classes({
      'padding-bottom-4': hasCons || !!bottomLine
    }) // Only pad bottom if section exists below

  });
  var consContent = /*#__PURE__*/React.createElement(OptionalListContent, {
    content: cons,
    contentLabel: "Cons",
    className: classes({
      'padding-bottom-4': !!bottomLine
    }) // Only pad bottom if section exists below

  });
  var prosCons = /*#__PURE__*/React.createElement(Fragment, null, prosContent, consContent);
  var ourTakeContent = /*#__PURE__*/React.createElement(KetoAccordionItemWrapper, {
    analyticsEnabled: enableAnalytics || !_isEmpty(analytics),
    entityName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$ourTakePro = analytics.ourTakeProps) === null || _analytics$ourTakePro === void 0 ? void 0 : _analytics$ourTakePro.entityName) || "".concat(entityNamePrefix, "our_take_content"),
    payload: {
      element_position: 1,
      section_name: (analytics === null || analytics === void 0 ? void 0 : (_analytics$ourTakePro2 = analytics.ourTakeProps) === null || _analytics$ourTakePro2 === void 0 ? void 0 : _analytics$ourTakePro2.sectionName) || sectionName,
      section_position: (analytics === null || analytics === void 0 ? void 0 : (_analytics$ourTakePro3 = analytics.ourTakeProps) === null || _analytics$ourTakePro3 === void 0 ? void 0 : _analytics$ourTakePro3.sectionPosition) || 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.accordionContent, " ").concat(styles.accordionContentPadding)
  }, prosCons, !!bottomLine && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Type, {
    bold: true
  }, "Why We Like It"), bottomLine)));

  var _useState = useState([initAccordionItemExpanded, false]),
      _useState2 = _slicedToArray(_useState, 2),
      expandedMap = _useState2[0],
      setExpandedMap = _useState2[1];

  var toggleItem = function toggleItem(index) {
    var newExpandedMap = [false, false];
    newExpandedMap[index] = !expandedMap[index];
    setExpandedMap(newExpandedMap);
  };

  var accordionItems = [{
    children: /*#__PURE__*/React.createElement(KetoAccordionItemWrapper, {
      analyticsEnabled: enableAnalytics || !_isEmpty(analytics),
      entityName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productDet = analytics.productDetailsProps) === null || _analytics$productDet === void 0 ? void 0 : _analytics$productDet.entityName) || "".concat(entityNamePrefix, "product_details_content"),
      payload: {
        element_position: 0,
        section_name: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productDet2 = analytics.productDetailsProps) === null || _analytics$productDet2 === void 0 ? void 0 : _analytics$productDet2.sectionName) || sectionName,
        section_position: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productDet3 = analytics.productDetailsProps) === null || _analytics$productDet3 === void 0 ? void 0 : _analytics$productDet3.sectionPosition) || 1
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.accordionContent, " ").concat(styles.accordionContentPadding)
    }, productDetails)),
    expanded: expandedMap[0],
    id: "".concat(entityNamePrefix, "product_details"),
    onSelect: function onSelect() {
      return toggleItem(0);
    },
    key: 'productDetails',
    title: /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.accordionTitle, " ").concat(styles.accordionContentPadding)
    }, "Product Details")
  }, {
    children: (hasPros || hasCons || !!bottomLine) && ourTakeContent,
    expanded: expandedMap[1],
    id: "".concat(entityNamePrefix, "our_take"),
    onSelect: function onSelect() {
      return toggleItem(1);
    },
    key: 'ourTake',
    title: /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.accordionTitle, " ").concat(styles.accordionContentPadding)
    }, "Our Take")
  }].filter(function (accordionItem) {
    return !!accordionItem.children;
  });
  return /*#__PURE__*/React.createElement(ControlledAccordion, {
    analytics: {
      enabled: enableAnalytics,
      payload: {
        elementName: buildAnalyticsEntityName((analytics === null || analytics === void 0 ? void 0 : (_analytics$payload = analytics.payload) === null || _analytics$payload === void 0 ? void 0 : _analytics$payload.elementName) || entityName)
      }
    },
    id: "keto_card_accordion",
    items: accordionItems,
    enableTracking: true
  });
};

KetoAccordion.propTypes = {
  bottomLine: PropTypes.node,
  cons: PropTypes.node,
  initAccordionItemExpanded: PropTypes.bool,
  productDetails: PropTypes.node,
  pros: PropTypes.node,
  enableAnalytics: PropTypes.bool,
  analytics: PropTypes.shape({
    ourTakeProps: PropTypes.shape({
      entityName: PropTypes.string,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number
    }),
    productDetailsProps: PropTypes.shape({
      entityName: PropTypes.string,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number
    }),

    /** @deprecated formally used for the accordion */
    payload: PropTypes.shape({
      elementName: PropTypes.string
    })
  })
};
KetoAccordion.defaultProps = {
  analytics: {},
  initAccordionItemExpanded: false
};
export default KetoAccordion;